import adminDashboard from "./adminDashboard";
import candidateDashboard from "./candidateDashboard";
import shared from "./shared";

export default {
    adminDashboard,
    candidateDashboard,
    shared
}